export {
  REIMBURSEMENTS_LIST_COLUMN_OPTIONS,
  REIMBURSEMENTS_LIST_LOCKED_COLUMN_IDS,
  REIMBURSEMENTS_LIST_CUSTOMIZABLE_COLUMN_OPTIONS,
  REIMBURSEMENTS_LIST_DATA_COLUMN_IDS,
  REIMBURSEMENTS_COLUMN_VISIBILITY_STORAGE_KEY,
} from './listColumns'

export { REIMBURSEMENT_DETAIL_TABS } from './detailTabs'
export { EMPTY_TOTALS, EMPTY_PAGINATION } from './listDefaults'
export { WORKFLOW_STATUS_FILTERS } from './workflowStatusFilters'
export type { WorkflowStatusFilter } from './workflowStatusFilters'

export const REIMBURSEMENTS_FILTER_SESSION_KEY = 'defaultlist_filter'

export const PER_PAGE_OPTIONS = [15, 30, 50, 100] as const

export const DEFAULT_PER_PAGE = 15

export const REIMBURSEMENT_TYPES = {
  SKIPPED: 'Skipped',
  EVICTION: 'Eviction',
} as const

export const RENTAL_STATUSES = {
  OPEN: 'Open',
  SUBMITTED: 'Submitted',
  CONCLUDED: 'Concluded',
} as const

export const DEFAULT_STATUSES = {
  INFO_NEEDED: 'Info Needed',
  ACTION_NEEDED: 'Action Needed',
  AWAITING_FINAL_INFO: 'Awaiting Final Info',
  READY_FOR_REVIEW: 'Ready For Review',
  IN_REVIEW: 'In Review',
  DENIED: 'Denied',
  PAID: 'Paid',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
} as const

export const PAST_CUSTOMER_OPTIONS = {
  CURRENT: '',
  PAST: '2',
  ALL: '1',
} as const

export const LIBERTY_ROLES = [
  'ROLE_ADMIN',
  'ROLE_EXECS',
  'ROLE_CUSTOMER_SERVICE',
  'ROLE_CUSTOMER_SERVICE_MANAGER',
  'ROLE_LIBERTY_DEFAULTS',
  'ROLE_LIBERTY_SALES',
  'ROLE_UNDERWRITER',
  'ROLE_LIBERTY_FIN_MGR',
  'EXTERNAL_INSURANCE',
  'ROLE_LIBERTY_ACCOUNTING',
  'ROLE_REFUND_APPROVAL',
] as const

export const REVIEW_DECISION_OPTIONS = [
  'Escalated to L3 Review',
  'L1 Recalculated',
  'L2 Approved',
  'L2 Approval Needed',
  'L2 Recalculated',
  'L3 Approved',
  'Resubmitted to L2',
  'Resubmitted to L3',
  'Returned to L1',
  'Returned to L2',
] as const

export const PAST_CUSTOMER_DROPDOWN = [
  { value: '0', label: 'Resident Status' },
  { value: '', label: 'Current Residents' },
  { value: '2', label: 'Past Residents' },
  { value: '1', label: 'All Residents' },
] as const

/** Roles allowed to override the reimbursement end date on the Calculation tab. */
export const REIMBURSEMENT_END_DATE_OVERRIDE_ROLES = ['ROLE_ADMIN', 'ROLE_LIBERTY_DEFAULTS'] as const

/** Max length of the cancel / deny / reopen reason note. */
export const CANCEL_CLAIM_REASON_MAX_LENGTH = 200

/** Liberty organisation id used when scoping list queries. */
export const LIBERTY_ORG_ID = 1

/** Poll cadence while an export job is running (Angular `pollingInterval = 30000`). */
export const EXPORT_POLL_INTERVAL_MS = 30000

/** Shown when the export API returns no `message` (Angular always calls `notify(result.message)`). */
export const EXPORT_QUEUED_FALLBACK =
  'Export queued. Status updates appear below; you can download the spreadsheet when it is ready.'

export const EXPORT_ALL_QUEUED_FALLBACK =
  'Export all queued. Status updates appear below; you can download the spreadsheet when it is ready.'

/** Rental statuses that trigger the Skipped/Eviction required-field save guard. */
export const SKIPPED_EVICTION_STATUSES: readonly string[] = ['SKIPPED', 'EVICTION']

/** Claim statuses hidden from non-Liberty roles in the list/detail status maps. */
export const STATUSES_HIDDEN_FROM_NON_LIBERTY: readonly string[] = [
  'External Review',
  'Payment Pending',
  'Re-Opened',
]

export const ADMIN_OR_LIBERTY_DEFAULTS: readonly string[] = ['ROLE_ADMIN', 'ROLE_LIBERTY_DEFAULTS']

export const ADMIN_OR_EXTERNAL_INSURANCE: readonly string[] = ['ROLE_ADMIN', 'EXTERNAL_INSURANCE']

export const CAN_MESSAGE_INSURANCE: readonly string[] = [
  'ROLE_ADMIN',
  'EXTERNAL_INSURANCE',
  'ROLE_LIBERTY_DEFAULTS',
]

/**
 * Mirrors Angular `company_roles` (basecomponent/layout/user-access.ts) — the PMC roles
 * whose fields Angular disables on a locked/denied claim (`disableforClaimDenied`).
 */
export const COMPANY_PROPERTY_ROLES: readonly string[] = [
  'ROLE_PROPERTY_MANAGER',
  'ROLE_PROPERTY_AGENT',
  'ROLE_PROPERTY_ADMIN',
  'ROLE_COMPANY_MANAGER',
  'ROLE_COMPANY_ADMIN',
  'ROLE_REGIONAL_MANAGER',
]
